import { configureStore } from '@reduxjs/toolkit';

import quizReducer from '@/features/quiz/quiz-client-state-slice';
import { apiSlice } from '@/features/quiz/quiz-api-slice';
import cartReducer from '@/features/cart/cart-slice';

const store = configureStore({
  reducer: {
    quiz: quizReducer,
    cart: cartReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware().concat(apiSlice.middleware);
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
